import { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import get from "lodash/get";
import { createStructuredSelector } from "reselect";
import {
  setData,
  clearData,
  fetchOrderDetails,
  mockPayment
} from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectOrderDetails,
  makeSelectMockPayment
} from "ducks/selectors";

import SmartRender from "containers/SmartRender";
import { urlParam } from "utils/helpers";

const mapStateToProps = (_, props) => {
  const type = get(props, "match.params.type", "");
  const txnId = urlParam("id");
  return createStructuredSelector({
    isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
    isMockingPayment: makeSelectIsFetchingData("mockPayment"),
    mockPayment: makeSelectMockPayment(),
    orderDetails: makeSelectOrderDetails(),
    txnId: () => txnId,
    type: () => type,
    mock: () => true
  });
};

export function mapDispatchToProps(dispatch) {
  return {
    clearOrderDetails: () => {
      dispatch(clearData("orderDetails"));
    },
    fetchOrderDetails: (orderParams, callback) => {
      dispatch(fetchOrderDetails(orderParams, callback));
    },
    clearMockPayment: () => {
      dispatch(clearData("mockPayment"));
    },
    mockPaymentSuccess: txnId => {
      dispatch(
        mockPayment({ order_ref: txnId, type: "success" }, () => {
          dispatch(
            setData({ key: "mockPayment", data: { status: "success" } })
          );
        })
      );
    },
    mockPaymentFailure: txnId => {
      dispatch(
        mockPayment({ order_ref: txnId, type: "failure" }, () => {
          dispatch(
            setData({ key: "mockPayment", data: { status: "failure" } })
          );
        })
      );
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(SmartRender);
